import React from "react";
import { connect } from "react-redux";
import { logout, setLocale } from "../../store/actions";
import UnauthorizedPage from "./UnauthorizedPage";

const Unauthorized = () => {
    return <UnauthorizedPage />;
};
export default connect(
    ({ user, fetch }) => ({
        user,
        fetch,
    }),
    {
        logout,
        setLocale,
    },
)(Unauthorized);
